import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'jhi-bary-input-multi-select',
  templateUrl: './bary-input-multi-select.component.html',
  styleUrls: ['./bary-input-multi-select.component.scss'],
})
export class BaryInputMultiSelectComponent {
  @Input() id = '';
  @Input() placeholder: string | undefined;
  @Input() label: string | undefined;
  @Input() name: string | undefined;
  @Input() disabled = false;
  @Input() control = new FormControl([]);
  @Input() tooltip?: string;
  @Input() options!: { label: string; value: any }[];
  @Input() title?: string;

  @Output() onChangeEvent = new EventEmitter<string[]>();
}
